// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.cakewallet",
    name: "Cake Wallet",
    homepage: "https://cakewallet.com/",
    image_id: "547998c5-7908-4f11-bdc3-93da789d8c00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/cake-wallet/id1334702542?platform=iphone",
        android: "https://play.google.com/store/apps/details?id=com.cakewallet.cake_wallet",
        mac: "https://apps.apple.com/us/app/cake-wallet/id1334702542?platform=mac",
        windows: null,
        linux: "https://github.com/cake-tech/cake_wallet/releases/tag/v4.10.0",
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "cakewallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map